import { DialogKey } from 'components/navigation/WithDialogs';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useOpenDialog } from 'hooks/navigation/useOpenDialog';
import { useQueryString } from 'hooks/useQueryString';

export const usePromptVerifyPhone = () => {
  const { currentUser } = useCurrentUserContext();

  const action = useQueryString('action');
  const dialogOpen = useQueryString(DialogKey.verifyPhone);
  const openDialog = useOpenDialog();

  if (
    action !== 'verifyPhone' ||
    !currentUser ||
    currentUser.phoneNumberVerified ||
    dialogOpen
  ) {
    return;
  }

  openDialog(DialogKey.verifyPhone, '1', { replace: true });
};
